import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { FormattedMessage } from 'component-utilities/intl';
import styles from './AppHeader.scss';

const BASE_KEY = 'components.app_header.app_switcher';

export default function AppSwitcherTab({ id, status, onClick }) {
    const componentProps = {
        className: styles[`tab-${status}`],
        onClick,
        'data-app': id,
        'data-active': status === 'active',
    };

    return (
        <div {...componentProps}>
            <FormattedMessage id={`${BASE_KEY}.${id}`} />
        </div>
    );
}

AppSwitcherTab.displayName = displayName('AppHeader/AppSwitcherTab');

AppSwitcherTab.propTypes = {
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    active: PropTypes.bool,
    status: PropTypes.string.isRequired,
};

AppSwitcherTab.defaultProps = {
    active: false,
    onClick: null,
};
